import { Scope } from '../../../jira/clients/response-types';

export const defaultPermissionsSupplier = () => {
	const response = Object.values(Scope);
	return Promise.resolve(response);
};
